import React from 'react';

function NotFoundPage() {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>404</h1>
      <p>Page not found.</p>
    </div>
  );
}

export default NotFoundPage;
